import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, class_type, int32_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { ProblemDetails_$reflection } from "../ServerTypes.fs.js";
import { FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Fetch_Types_Response__Response_ProblemDetails, Thoth_Fetch_FetchError__FetchError_get_Message } from "../Prelude.fs.js";
import { value, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";

export class FetchFail extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ProblemDetails", "FetchError", "Error"];
    }
}

export function FetchFail_$reflection() {
    return union_type("EPM.App.Hooks.UseFetch.FetchFail", [], FetchFail, () => [[["Item1", int32_type], ["Item2", ProblemDetails_$reflection()]], [["Item", FetchError_$reflection()]], [["Item", class_type("System.Exception")]]]);
}

export function FetchFail__get_Message(this$) {
    switch (this$.tag) {
        case 1:
            return Thoth_Fetch_FetchError__FetchError_get_Message(this$.fields[0]);
        case 2:
            return this$.fields[0].message;
        default:
            return `Code:${this$.fields[0]} - ${this$.fields[1].Title}`;
    }
}

export class Fetched$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["HasNotStartedYet", "InProgress", "Resolved", "Failed"];
    }
}

export function Fetched$1_$reflection(gen0) {
    return union_type("EPM.App.Hooks.UseFetch.Fetched`1", [gen0], Fetched$1, () => [[], [], [["Item", gen0]], [["Item", FetchFail_$reflection()]]]);
}

export function Fetched$1_toOption_50D43789(x) {
    if (x.tag === 2) {
        return some(x.fields[0]);
    }
    else {
        return undefined;
    }
}

export function useFeliz_React__React_useFetch_Static_6ADA66EC(operation, parameters, dependencies) {
    const patternInput = reactApi.useState(new Fetched$1(0, []));
    const setDeferred = patternInput[1];
    reactApi.useEffect(() => {
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (PromiseBuilder__Delay_62FBFDE1(promise, () => {
            setDeferred(new Fetched$1(1, []));
            return operation(parameters).then((_arg) => {
                const output = _arg;
                if (output.tag === 1) {
                    const error = output.fields[0];
                    if (error.tag === 2) {
                        const response = error.fields[0];
                        return Fetch_Types_Response__Response_ProblemDetails(response).then((_arg_1) => {
                            const problemDetailsOpt = _arg_1;
                            if (problemDetailsOpt == null) {
                                console.warn(some("Fetch Failed"), response);
                                setDeferred(new Fetched$1(3, [new FetchFail(1, [error])]));
                                return Promise.resolve();
                            }
                            else {
                                const problemDetails = problemDetailsOpt;
                                console.warn(some("Fetch Failed"), problemDetails);
                                setDeferred(new Fetched$1(3, [new FetchFail(0, [response.status, problemDetails])]));
                                return Promise.resolve();
                            }
                        });
                    }
                    else {
                        console.warn(some("Fetch Failed"), error);
                        setDeferred(new Fetched$1(3, [new FetchFail(1, [error])]));
                        return Promise.resolve();
                    }
                }
                else {
                    setDeferred(new Fetched$1(2, [output.fields[0]]));
                    return Promise.resolve();
                }
            });
        }).catch((_arg_2) => {
            const error_1 = _arg_2;
            console.error(some(error_1));
            setDeferred(new Fetched$1(3, [new FetchFail(2, [error_1])]));
            return Promise.resolve();
        }))));
        void pr;
    }, dependencies);
    return patternInput[0];
}

export function useFeliz_React__React_useOptionalFetch_Static_5B82200F(operation, parameters, dependencies) {
    const patternInput = reactApi.useState(new Fetched$1(0, []));
    const setDeferred = patternInput[1];
    reactApi.useEffect(() => {
        if (parameters != null) {
            let pr;
            const parameters_1 = value(parameters);
            pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (PromiseBuilder__Delay_62FBFDE1(promise, () => {
                setDeferred(new Fetched$1(1, []));
                return operation(parameters_1).then((_arg) => {
                    const output = _arg;
                    if (output.tag === 1) {
                        const error = output.fields[0];
                        if (error.tag === 2) {
                            const response = error.fields[0];
                            return Fetch_Types_Response__Response_ProblemDetails(response).then((_arg_1) => {
                                const problemDetailsOpt = _arg_1;
                                if (problemDetailsOpt == null) {
                                    setDeferred(new Fetched$1(3, [new FetchFail(1, [error])]));
                                    return Promise.resolve();
                                }
                                else {
                                    const problemDetails = problemDetailsOpt;
                                    setDeferred(new Fetched$1(3, [new FetchFail(0, [response.status, problemDetails])]));
                                    return Promise.resolve();
                                }
                            });
                        }
                        else {
                            setDeferred(new Fetched$1(3, [new FetchFail(1, [error])]));
                            return Promise.resolve();
                        }
                    }
                    else {
                        setDeferred(new Fetched$1(2, [output.fields[0]]));
                        return Promise.resolve();
                    }
                });
            }).catch((_arg_2) => {
                const error_1 = _arg_2;
                console.error(some(error_1));
                setDeferred(new Fetched$1(3, [new FetchFail(2, [error_1])]));
                return Promise.resolve();
            }))));
            void pr;
        }
    }, dependencies);
    return patternInput[0];
}

